module.exports = __webpack_public_path__ + "static/mbpc-logo-white.cd7fb2e8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/mbpc-logo-white.svg
// module id = 1041
// module chunks = 114276838955818